<template>
  <div class="content-text-slide">
    <div class="form-group">
      <label class="label-option">{{ $i18nPresenter.t('Subheading') }}</label>
      <TextArea
        @interface="updateSlide"
        :val="slideActive.subheading"
        :place-holder="$i18nPresenter.t('Subheading or paragraphs here…')"
        :rows="subheadingRow"
        :limit="subheadingLimit"
        :id-name="'subheading-slide-edit'"
        class="text-slide--textarea"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TextArea from '@/components/presentations/TextArea'

export default {
  components: {
    TextArea,
  },
  data() {
    const slideType = this.$store.state.slideActive.type
    let limit = 150
    let subheadingRow = 2
    if (slideType === 'textSlide') {
      limit = 500
      subheadingRow = 10
    }
    return {
      subheadingRow,
      subheadingLimit: limit,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
  methods: {
    updateSlide(newValue) {
      this.$emit('updateSlide', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.text-slide--textarea {
  &::v-deep textarea {
    overflow-y: auto;
  }
}
</style>
